/**
 * PD Video Autoplay Fix
 * Shrine temasının internal-video elementinde IntersectionObserver
 * data-src → src swap'ını tetiklemediği durumlar için fallback.
 * 1.5s sonra hala yüklenmemiş videoları zorla yükler.
 */
(function () {
  function fixVideos() {
    document.querySelectorAll('internal-video').forEach(function (el) {
      var sources = el.querySelectorAll('source[data-src]');
      if (sources.length === 0) return;
      sources.forEach(function (s) {
        s.src = s.dataset.src;
        s.removeAttribute('data-src');
      });
      var video = el.querySelector('video');
      if (video) {
        video.load();
        video.play().catch(function () {});
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      setTimeout(fixVideos, 1500);
    });
  } else {
    setTimeout(fixVideos, 1500);
  }
})();
